{
  "alert": "Advarsel",
  "dismiss": "Luk"
}